<template>
  <div>
    <KTCodePreview v-bind:title="'In phiếu'">
      <template v-slot:toolbar>
        <b-button
          variant="primary"
          size="sm"
          @click="printData"
          style="width: max-content"
        >
          <i class="fas fa-print"></i>
          In phiếu
        </b-button>
      </template>
      <template v-slot:preview>
        <div id="printMe">
          <b-row style="display: block" class="mb-10">
            <div class="text-center">
              <h5>PHIẾU YÊU CẦU NHẬP HÀNG</h5>
            </div>
          </b-row>
          <b-row>
            <b-col md="8">
              <p>
                <span class="custom-lable-text">Mã phiếu</span>
                : {{ po.code }}
              </p>
            </b-col>
            <b-col md="4">
              <p>
                <span class="custom-lable-text">Kho</span>
                : {{ po.store && po.store.name }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <p>
                <span class="custom-lable-text">Ngày</span>
                : {{ formatDate(po.createdAt, 'HH:mm:ss DD/MM/YYYY') }}
              </p>
            </b-col>
            <b-col md="4">
              <p>
                <span class="custom-lable-text">Địa chỉ</span>
                : {{ po.store && po.store.address }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <p>
                <span class="custom-lable-text"> Nhà cung cấp </span>
                : {{ po.provider && po.provider.name }}
              </p>
            </b-col>
            <b-col md="4">
              <p>
                <span class="custom-lable-text">Người lập</span>
                : {{ po.createdByUser && po.createdByUser.fullName }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <p>
                <span class="custom-lable-text">Điện thoại</span>
                : {{ po.provider && po.provider.phoneNumber }}
              </p>
            </b-col>
            <b-col md="4">
              <p>
                <span class="custom-lable-text">Trạng thái</span>
                : {{ statusName }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <p>
                <span class="custom-lable-text">Ghi chú</span>
                : {{ po.description }}
              </p>
            </b-col>
          </b-row>
          <b-row v-if="isCanceled">
            <b-col md="8">
              <p>
                <span class="custom-lable-text">Lý do hủy</span>
                : {{ po.cancelReason }}
              </p>
            </b-col>
          </b-row>
          <b-table
            :items="listItem"
            :fields="fields"
            :bordered="true"
            :hover="true"
          >
            <template slot="bottom-row">
              <td
                v-bind:colspan="3"
                class="text-right font-weight-bolder"
                style="font-weight: 600; color: '#181c32'"
              >
                <span>Tổng:</span>
              </td>
              <td class="text-right font-weight-bolder">
                <span>{{ formatMoney(sumQuantity) }}</span>
              </td>
              <template v-if="isApproved">
                <td class="text-right font-weight-bolder"></td>
                <td class="text-right font-weight-bolder">
                  <span>{{ formatMoney(sumDiscountAmount) }}</span>
                </td>
                <td class="text-right font-weight-bolder">
                  <span>{{ formatMoney(sumVatAmount) }}</span>
                </td>
                <td class="text-right font-weight-bolder">
                  <span>{{ formatMoney(sumTotalAmount) }}</span>
                </td>
              </template>
            </template>
          </b-table>
          <template v-if="isApproved">
            <b-row>
              <b-col md="8">
                <p>
                  <span class="custom-lable-text">Tổng tiền hàng</span>
                  : {{ formatMoney(po.totalGoods) }}
                </p>
              </b-col>
              <b-col md="4">
                <p>
                  <span class="custom-lable-text">Chiết khấu</span>
                  : {{ formatMoney(po.discountAmount) }}
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8">
                <p>
                  <span class="custom-lable-text">Thuế VAT</span>
                  : {{ formatMoney(po.vatAmount) }}
                </p>
              </b-col>
              <b-col md="4">
                <p>
                  <span class="custom-lable-text">Tổng thanh toán</span>
                  : {{ formatMoney(po.totalAmount) }}
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <p>
                  <span class="custom-lable-text"
                    >Tổng số tiền (viết bằng chữ)</span
                  >
                  : {{ textAmount }}
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <p>
                  <span class="custom-lable-text">Tiền mặt</span>
                  : {{ formatMoney(po.cashAmount) }}
                </p>
              </b-col>
              <b-col md="4">
                <p>
                  <span class="custom-lable-text">Chuyển khoản</span>
                  : {{ formatMoney(po.transferAmount) }}
                </p>
              </b-col>
              <b-col md="4">
                <p>
                  <span class="custom-lable-text">Công nợ</span>
                  : {{ formatMoney(po.debtAmount) }}
                </p>
              </b-col>
            </b-row>
          </template>
          <b-row>
            <b-col class="text-center">
              <p class="mb-0">
                <span class="custom-lable-text">Người lập phiếu</span>
              </p>
              <p>(Ký, họ tên)</p>
            </b-col>
            <b-col>
              <p class="mb-0">
                <span class="custom-lable-text">Người giao hàng</span>
              </p>
              <p>(Ký, họ tên)</p>
            </b-col>
            <b-col>
              <p class="mb-0">
                <span class="custom-lable-text">Người nhận hàng</span>
              </p>
              <p>(Ký, họ tên)</p>
            </b-col>
            <b-col
              ><p class="mb-0">
                <span class="custom-lable-text">Thủ kho</span>
              </p>
              <p>(Ký, họ tên)</p>
            </b-col>
            <b-col
              ><p class="mb-0">
                <span class="custom-lable-text">Giám đốc</span>
              </p>
              <p>(Ký, họ tên)</p>
            </b-col>
          </b-row>
        </div>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import PurchaseOrderService from '@/core/api/purchase-order/purchase-order.service';
import { PurchaseOrderModel } from '@/core/models/PurchaseOrder.model';
import { PURCHASE_ORDER_STATUS } from '@/utils/enum';
import _ from 'lodash';
import {
  convertNumberToText,
  printData,
  convertPrice,
  formatDate,
} from '../../../utils/common';

// Nhãn trạng thái — đồng bộ với List.vue.
const PO_STATUS_NAME = {
  [PURCHASE_ORDER_STATUS.NEW]: 'Mới',
  [PURCHASE_ORDER_STATUS.READY]: 'Yêu cầu duyệt',
  [PURCHASE_ORDER_STATUS.PURCHASED]: 'Đã duyệt',
  [PURCHASE_ORDER_STATUS.ACCOUNTANT]: 'Đã xác nhận',
  [PURCHASE_ORDER_STATUS.CANCELED]: 'Đã huỷ',
};

export default {
  components: {
    KTCodePreview,
  },
  data() {
    return {
      po: new PurchaseOrderModel({}),
    };
  },
  computed: {
    // PO đã qua duyệt (Trưởng ngành hàng / Kế toán) → in đầy đủ tiền + thanh toán.
    // PO chưa duyệt chỉ in nội dung yêu cầu (SL yêu cầu).
    isApproved() {
      return (
        this.po.status === PURCHASE_ORDER_STATUS.PURCHASED ||
        this.po.status === PURCHASE_ORDER_STATUS.ACCOUNTANT
      );
    },
    isCanceled() {
      return this.po.status === PURCHASE_ORDER_STATUS.CANCELED;
    },
    statusName() {
      return PO_STATUS_NAME[this.po.status] || '';
    },
    // Cột bảng động theo trạng thái — đã duyệt mới có cột giá/chiết khấu/VAT/thành tiền.
    fields() {
      const moneyTd = (value) => this.formatMoney(value);
      const base = [
        {
          key: 'count',
          label: 'STT',
          thStyle: {
            textAlign: 'center',
            fontWeight: 600,
            color: '#181c32',
            width: '4%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'productCode',
          label: 'Mã sản phẩm',
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
        },
        {
          key: 'productName',
          label: 'Tên sản phẩm',
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'quantity',
          label: this.isApproved ? 'SL duyệt' : 'SL yêu cầu',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '8%' },
          tdClass: 'text-right',
          formatter: moneyTd,
        },
      ];
      if (!this.isApproved) {
        return base;
      }
      return [
        ...base,
        {
          key: 'unitPrice',
          label: 'Giá',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '12%' },
          tdClass: 'text-right',
          formatter: moneyTd,
        },
        {
          key: 'discountAmount',
          label: 'Chiết khấu',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '12%' },
          tdClass: 'text-right',
          formatter: moneyTd,
        },
        {
          key: 'vatAmount',
          label: 'VAT',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '12%' },
          tdClass: 'text-right',
          formatter: moneyTd,
        },
        {
          key: 'totalAmount',
          label: 'Thành tiền',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '12%' },
          tdClass: 'text-right',
          formatter: moneyTd,
        },
      ];
    },
    listItem() {
      return (this.po.details || []).map((d, index) => ({
        count: index + 1,
        productCode: d.productCode,
        productName: d.productName,
        quantity: this.isApproved ? d.quantityApprove : d.quantity,
        unitPrice: d.unitPrice,
        discountAmount: d.discountAmount,
        vatAmount: d.vatAmount,
        totalAmount: d.totalAmount,
      }));
    },
    sumQuantity() {
      return _.sumBy(this.listItem, 'quantity');
    },
    sumDiscountAmount() {
      return _.sumBy(this.listItem, 'discountAmount');
    },
    sumVatAmount() {
      return _.sumBy(this.listItem, 'vatAmount');
    },
    sumTotalAmount() {
      return _.sumBy(this.listItem, 'totalAmount');
    },
    // Số tiền viết bằng chữ lấy từ tổng thanh toán BE đã chốt.
    textAmount() {
      return convertNumberToText(this.po.totalAmount);
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: 'In phiếu kho' }]);
    this.getPurchaseOrderById();
  },
  methods: {
    printData() {
      printData();
    },
    formatDate,
    formatMoney(number) {
      return convertPrice(number);
    },
    async getPurchaseOrderById() {
      const id = this.$route.query.id;
      try {
        const { data } = await PurchaseOrderService.getById(id);
        this.po = PurchaseOrderModel.fromJson(data.data);
      } catch (e) {
        // bỏ qua lỗi fetch phiếu
      }
      printData();
    },
  },
};
</script>

<style scoped>
.custom-lable-text {
  font-size: 13px;
  font-weight: 500 !important;
}
</style>

<style>
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}
.table.b-table.table-sm
  > tfoot
  > tr
  > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(1.5rem / 2) center;
  padding-right: calc(0.3rem + 0.65em);
}
</style>
